import { Component, OnInit } from "@angular/core";
import { RegistrationService } from "src/app/registration/registration.service";
import { HttpErrorResponse } from "@angular/common/http";
import { SharedService } from "../shared.service";

@Component({
  selector: "app-privacypolicy",
  templateUrl: "./privacypolicy.component.html",
  styleUrls: ["./privacypolicy.component.scss"],
})
export class PrivacypolicyComponent implements OnInit {
  policy: any;
  constructor(
    private doctorService: RegistrationService,
    private sharedService: SharedService,
  ) {
    this.getPrivacy();
  }

  ngOnInit() {}
  getPrivacy() {
    this.doctorService.getPrivacyPolicy().subscribe({
      next: (res: any) => {
        this.policy = res.data[0];
      },
      error: (error: HttpErrorResponse) => {
        this.handleError(error);
      },
    });
  }

  handleError(error) {
    this.sharedService.handleError(error);
  }
}
